(function () {
  // Mappa stato numerico -> valori opzione variante (leggibili in carrello/ordine)
  const COUNT_OPT = { 1: '1 animaletto', 2: '2 animaletti', 3: '3 animaletti' };
  const TAGS_OPT = { 0: 'Nessuna', 1: '1 targhetta', 2: '2 targhette', 3: '3 targhette' };


  function fmtMoney(cents) {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
    }).format(cents / 100);
  }

  function getData(root) {
    const el = root.querySelector('[data-gg-al-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  class GgAnimalettoConfigurator {
    constructor(root) {
      this.root = root;
      this.data = getData(root);
      if (!this.data) return;

      this.state = {
        count: 1, // 1..3 animaletti  -> option1 variante
        tags: 0, // 0..3 targhette   -> option2 variante
        photos: [], // File objects, indice = animale
      };

      this.els = {
        form: root.querySelector('form.gg-al-form'),
        variantId: root.querySelector('[data-gg-al-variant-id]'),
        countOpts: root.querySelectorAll('[data-al-count]'),
        tagOpts: root.querySelectorAll('[data-al-tags]'),
        files: root.querySelectorAll('[data-al-file]'),
        upzone: root.querySelector('[data-al-upzone]'),
        slots: root.querySelector('[data-al-slots]'),
        tagInputs: root.querySelector('[data-al-taginputs]'),
        nameFields: root.querySelectorAll('[data-al-name]'),
        price: root.querySelector('[data-al-price]'),
        klarna: root.querySelector('[data-al-klarna]'),
        klarnaRate: root.querySelector('[data-al-klarna-rate]'),
        error: root.querySelector('[data-al-error]'),
        addBtn: root.querySelector('[data-al-add]'),
        gmain: root.querySelector('[data-al-gmain]'),
        gtag: root.querySelector('[data-al-gtag]'),
        gthumbs: root.querySelectorAll('[data-al-gth]'),
      };

      this.decorateCountOpts();
      this.bind();
      this.renderSlots();
      this.renderTagInputs();
      this.syncFields();
      this.recalc();
    }

    /* --- lookup varianti (option1 = count, option2 = tags) --- */
    getVariant(count, tags) {
      const co = COUNT_OPT[count == null ? this.state.count : count];
      const to = TAGS_OPT[tags == null ? this.state.tags : tags];
      return (this.data.variants || []).find(
        (v) => v.option1 === co && v.option2 === to
      );
    }

    decorateCountOpts() {
      // Lo sconto quantità è RICAVATO dai prezzi delle varianti, non scritto a
      // mano: così la percentuale mostrata non può mentire e resta giusta anche
      // se il listino cambia. Arrotondata per difetto, mai in eccesso.
      const unitario = this.getVariant(1, 0);
      this.els.countOpts.forEach((btn) => {
        const c = parseInt(btn.dataset.alCount, 10);
        const variante = this.getVariant(c, 0);
        const pl = btn.querySelector('.pl');
        if (!pl) return;
        let off = '';
        if (unitario && variante && c > 1) {
          const pieno = unitario.price * c;
          if (pieno > variante.price) {
            off = '-' + Math.floor((1 - variante.price / pieno) * 100) + '%';
          }
        }
        pl.textContent = off;
        pl.classList.toggle('is-off', !!off);
      });
    }

    /* Prezzo sotto ogni opzione, preso dalla variante corrispondente:
       - animaletti -> prezzo effettivo di quella scelta con le targhette
         attualmente selezionate (coincide col totale del buy box);
       - targhette  -> quanto costa in più l'aggiunta rispetto a "Nessuna".
       Mai il prezzo unitario moltiplicato, altrimenti il totale non torna. */
    renderOptionPrices() {
      this.els.countOpts.forEach((btn) => {
        const el = btn.querySelector('[data-al-optprice]');
        if (!el) return;
        const variante = this.getVariant(parseInt(btn.dataset.alCount, 10), this.state.tags);
        el.textContent = variante ? fmtMoney(variante.price) : '';
      });

      const senzaTarghette = this.getVariant(this.state.count, 0);
      this.els.tagOpts.forEach((btn) => {
        const el = btn.querySelector('[data-al-optprice]');
        if (!el) return;
        const tags = parseInt(btn.dataset.alTags, 10);
        const variante = this.getVariant(this.state.count, tags);
        if (!variante || !senzaTarghette || tags === 0) {
          el.textContent = '';
          return;
        }
        const differenza = variante.price - senzaTarghette.price;
        el.textContent = differenza > 0 ? '+' + fmtMoney(differenza) : '';
      });
    }

    bind() {
      this.els.countOpts.forEach((btn) => {
        btn.addEventListener('click', () => this.selectCount(btn));
      });
      this.els.tagOpts.forEach((btn) => {
        btn.addEventListener('click', () => this.selectTags(btn));
      });
      this.els.files.forEach((input, idx) => {
        input.addEventListener('change', () => this.onFile(input, idx));
      });
      this.els.gthumbs.forEach((th) => {
        th.addEventListener('click', () => this.selectThumb(th));
      });
      if (this.els.form) {
        this.els.form.addEventListener('submit', (e) => this.onSubmit(e));
      }
    }

    selectCount(btn) {
      this.els.countOpts.forEach((o) => o.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      this.state.count = parseInt(btn.dataset.alCount, 10);
      if (this.state.photos.length > this.state.count) {
        this.state.photos = this.state.photos.slice(0, this.state.count);
      }
      this.renderSlots();
      this.syncFields();
      this.recalc();
    }

    selectTags(btn) {
      this.els.tagOpts.forEach((o) => o.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      this.state.tags = parseInt(btn.dataset.alTags, 10);
      this.renderTagInputs();
      this.syncFields();
      this.recalc();
    }

    onFile(input, idx) {
      const file = input.files && input.files[0];
      if (file) this.state.photos[idx] = file;
      this.renderSlots();
    }

    /* mostra/nasconde e disabilita gli input file e nome oltre count/tags,
       così le proprietà inutili non finiscono nel form */
    syncFields() {
      this.els.files.forEach((input, idx) => {
        const active = idx < this.state.count;
        input.disabled = !active;
        if (!active) {
          input.value = '';
          this.state.photos[idx] = undefined;
        }
      });
      this.els.nameFields.forEach((input, idx) => {
        const active = idx < this.state.tags;
        input.disabled = !active;
        input.closest('[data-al-name-row]')?.classList.toggle('is-hidden', !active);
      });
    }

    renderSlots() {
      const box = this.els.slots;
      if (!box) return;
      box.innerHTML = '';
      for (let i = 0; i < this.state.count; i += 1) {
        const slot = document.createElement('div');
        slot.className = 'gg-al-slot';
        const file = this.state.photos[i];
        if (file) {
          const url = URL.createObjectURL(file);
          slot.style.backgroundImage = `url(${url})`;
          const x = document.createElement('span');
          x.className = 'x';
          x.textContent = '×';
          x.addEventListener('click', (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            this.removePhoto(i);
          });
          slot.appendChild(x);
        } else {
          slot.classList.add('is-empty');
          slot.textContent = '＋';
          slot.addEventListener('click', () => {
            if (this.els.files[i]) this.els.files[i].click();
          });
        }
        box.appendChild(slot);
      }
    }

    removePhoto(i) {
      this.state.photos[i] = undefined;
      if (this.els.files[i]) this.els.files[i].value = '';
      this.renderSlots();
    }

    renderTagInputs() {
      // i campi nome sono gia' nel form; qui gestiamo solo la visibilita'
      this.els.nameFields.forEach((input, idx) => {
        const row = input.closest('[data-al-name-row]');
        if (row) row.classList.toggle('is-hidden', idx >= this.state.tags);
      });
    }

    selectThumb(th) {
      this.els.gthumbs.forEach((o) => o.classList.remove('is-selected'));
      th.classList.add('is-selected');
      const src = th.dataset.full;
      const label = th.dataset.label || '';
      // galleria manuale (blocchi editor): il markup grande — anche <video>
      // con le sue sorgenti — sta gia' pronto nel <template> della miniatura
      const tpl = th.querySelector('template[data-al-full]');
      if (tpl && this.els.gmain) {
        this.els.gmain.innerHTML = tpl.innerHTML;
        const v = this.els.gmain.querySelector('video');
        if (v) {
          v.muted = true; // Safari ignora l'attributo su nodi inseriti via JS
          if (v.play) v.play().catch(() => {});
        }
      } else if (src && this.els.gmain) {
        /* width/height vanno riportati sull'immagine grande: da quando il
           riquadro segue il formato della foto (Marco 05/08) un img senza
           dimensioni lo farebbe collassare a zero fino a scaricamento finito,
           e la pagina salterebbe a ogni cambio miniatura. Le prende dalla
           miniatura, che le ha gia' dal Liquid. */
        const thumb = th.querySelector('img');
        const w = thumb && thumb.getAttribute('width');
        const h = thumb && thumb.getAttribute('height');
        const size = w && h ? ` width="${w}" height="${h}"` : '';
        this.els.gmain.innerHTML = `<img src="${src}"${size} alt="">`;
      }
      if (this.els.gtag) this.els.gtag.textContent = label;
    }

    recalc() {
      const variant = this.getVariant();
      const total = variant ? variant.price : 0;
      this.renderOptionPrices();
      if (this.els.variantId) this.els.variantId.value = variant ? variant.id : '';
      if (this.els.price) this.els.price.textContent = fmtMoney(total);
      if (this.els.klarna && this.els.klarnaRate) {
        if (total >= 4000) {
          this.els.klarna.style.display = 'block';
          this.els.klarnaRate.textContent = fmtMoney(total / 3);
        } else {
          this.els.klarna.style.display = 'none';
        }
      }
    }

    showError(msg) {
      if (!this.els.error) return;
      this.els.error.textContent = msg;
      this.els.error.classList.add('is-visible');
      this.els.error.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    hideError() {
      if (this.els.error) this.els.error.classList.remove('is-visible');
    }

    onSubmit(e) {
      this.hideError();

      const variant = this.getVariant();
      if (!variant) {
        e.preventDefault();
        this.showError('Combinazione non disponibile. Controlla le varianti del prodotto in Shopify.');
        return;
      }

      // Validazione foto RIMOSSA (Marco 08/08): il caricamento non fa piu'
      // parte del flusso (le foto arrivano via mail dopo l'ordine). La vecchia
      // guardia del 06/08 era anche fallata: senza input in pagina partiva da
      // -1 e con 2-3 animaletti bloccava comunque l'aggiunta al carrello.

      // un nome per ogni targhetta scelta
      for (let i = 0; i < this.state.tags; i += 1) {
        const nf = this.els.nameFields[i];
        if (nf && !nf.value.trim()) {
          e.preventDefault();
          this.showError('Scrivi il nome per ogni targhetta scelta.');
          nf.focus();
          return;
        }
      }

      // ok: assicura variant id aggiornato, poi aggiunta via AJAX (apre il
      // drawer invece di navigare su /cart, stesso pattern di gg-frasi-
      // configurator.js e gg-crea-configurator.js). Niente piu' campi file
      // nel form (vedi nota foto sopra), FormData basta cosi' com'e'.
      e.preventDefault();
      if (this.els.variantId) this.els.variantId.value = variant.id;
      if (this.els.addBtn) this.els.addBtn.classList.add('is-loading');

      fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(this.els.form),
      })
        .then((res) => res.json().then((body) => ({ ok: res.ok, body })))
        .then(({ ok, body }) => {
          if (!ok) throw new Error(body.description || body.message || 'Errore carrello');
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        })
        .catch((err) => this.showError(err.message || 'Non siamo riusciti ad aggiungere al carrello.'))
        .finally(() => {
          if (this.els.addBtn) this.els.addBtn.classList.remove('is-loading');
        });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('[data-gg-al-root]')
      .forEach((el) => new GgAnimalettoConfigurator(el));
  });
})();
